import React, {Component, Fragment} from 'react';
import * as items from 'items/actions/items';
import {Button} from 'reactstrap';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import {connect} from 'react-redux';

@connect(
    state => (
        {
            items: state.items
        }
    ),
    dispatch => (
        {
            delete: item => dispatch(items.remove(item))
        }
    )
)
export default class DeleteItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        }
    }

    @autobind
    toggleModal() {
        this.setState(
            {
                ...this.state,
                isModalOpen: !this.state.isModalOpen
            }
        );
    }

    @autobind
    confirm() {
        this.props.delete(this.props.item.id);
        this.toggleModal();
    }

    render() {
        return (
            <Fragment>
                <Button onClick={this.toggleModal} color='danger'>
                    <i className='fa fa-times'> </i>
                </Button>
                <Dialog
                    toggle={this.toggleModal}
                    confirm={this.confirm}
                    isOpen={this.state.isModalOpen}
                    title={'Posten löschen'}
                >
                    Sind Sie Sicher?
                </Dialog>
            </Fragment>
        )
    }

}